import React from "react";
import Footer from "../../../components/Footer";
import useQueryParams from "../../../hooks/useQueryParams";
import CommonLayout from "../CommonLayout";
import { Filters } from "./components/Filters";
import { RulesStatementButton } from "./components/RulesStatementButton";
import Table from "./components/Table";
import { NOTIFICATIONS_TABLE_COLUMNS } from "./config/tables";
import { useFetchNotifications } from "./hooks/useFetchNotifications";
import { FiltersType } from "./types/filters.type";
import { useTableFiltersCursor } from "../../../hooks/useTableFiltersCursor";

const TABLE_KEY = "whatsapp";

const WhatsAppContainer = (): React.ReactNode => {
  const { invoiceId } = useQueryParams(["invoiceId"]);
  const { queryFilters, setQueryFilters, cursor, setCursor } =
    useTableFiltersCursor<FiltersType>(TABLE_KEY, (savedFilters) =>
      invoiceId
        ? { ...(savedFilters ?? {}), invoiceId }
        : savedFilters ?? ({} as FiltersType)
    );
  const { notifications, nextCursor, isLoading } = useFetchNotifications(
    queryFilters,
    cursor
  );

  const filters = (
    <Filters queryFilters={queryFilters} setQueryFilters={setQueryFilters} />
  );
  const buttons = <RulesStatementButton />;
  const table = <Table isLoading={isLoading} notifications={notifications} />;
  const footer = (
    <Footer
      tableProps={{
        fileName: "notificaciones",
        items: notifications,
        columns: NOTIFICATIONS_TABLE_COLUMNS,
        pagination: { tableKey: TABLE_KEY, nextCursor, setCursor, cursor },
      }}
    />
  );

  return CommonLayout({
    title: "Whatsapp",
    subtitle: "Consulta las notificaciones de Whatsapp enviadas por Palomma",
    filters,
    buttons,
    table,
    footer,
  });
};

export default WhatsAppContainer;
